export default __webpack_public_path__ + "static/media/model-s-mobile.8553bf9c.jpeg";